import { TikTokView } from "../ws7/analytics/TikTokView";
import "../ws7/ws7.css";

/** /tiktok?sort=views|uses|avg&song=<id>: TikTok analytics (songs → segments, watched profiles). */
export function TikTokAnalyticsPage() {
  return <TikTokView />;
}
